/* Cart core: AJAX add/change with drawer + cart-page section re-rendering. Native forms remain the no-JS fallback. */
(function () {
  'use strict';
  if (window.__bbCartInitialized) return;
  window.__bbCartInitialized = true;

  const BB = window.BB;
  const routes = BB.config.routes;
  const DRAWER_SECTION = 'bb-cart-drawer';

  function ajaxUrl(route) {
    if (!route) return route;
    return /\.js(?:\?|$)/.test(route) ? route : route.replace(/\/$/, '') + '.js';
  }

  function pageSection() {
    return document.querySelector('[data-cart-page-section]');
  }

  function sectionIds() {
    const ids = [];
    if (document.querySelector('bb-cart-drawer')) ids.push(DRAWER_SECTION);
    const page = pageSection();
    if (page && page.dataset.cartPageSection) ids.push(page.dataset.cartPageSection);
    return ids;
  }

  function sectionParam() {
    return sectionIds().join(',');
  }

  function renderCartSections(sections) {
    if (!sections) return;

    const drawer = document.querySelector('bb-cart-drawer');
    if (drawer && sections[DRAWER_SECTION]) {
      const doc = new DOMParser().parseFromString(sections[DRAWER_SECTION], 'text/html');
      const body = doc.querySelector('[data-cart-drawer-body]');
      const footer = doc.querySelector('[data-cart-drawer-footer]');
      const count = doc.querySelector('[data-cart-drawer-count]');
      const currentBody = drawer.querySelector('[data-cart-drawer-body]');
      const currentFooter = drawer.querySelector('[data-cart-drawer-footer]');
      const currentCount = drawer.querySelector('[data-cart-drawer-count]');
      if (body && currentBody) currentBody.innerHTML = body.innerHTML;
      if (footer && currentFooter) {
        currentFooter.innerHTML = footer.innerHTML;
        currentFooter.hidden = footer.hidden;
      }
      if (count && currentCount) currentCount.innerHTML = count.innerHTML;
    }

    const currentPage = pageSection();
    const pageId = currentPage && currentPage.dataset.cartPageSection;
    if (currentPage && pageId && sections[pageId]) {
      const pendingNote = currentPage.querySelector('#cart-note')?.value;
      const doc = new DOMParser().parseFromString(sections[pageId], 'text/html');
      const fresh = doc.querySelector('[data-cart-page-section]');
      if (fresh) {
        currentPage.innerHTML = fresh.innerHTML;
        if (pendingNote !== undefined) {
          const nextNote = currentPage.querySelector('#cart-note');
          if (nextNote) nextNote.value = pendingNote;
        }
      }
    }
  }

  function updateBadges(cart) {
    document.querySelectorAll('[data-bb-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    document.querySelectorAll('[data-cart-total]').forEach((el) => {
      el.textContent = BB.formatMoney(cart.total_price);
    });
  }

  function setLineBusy(line, busy) {
    if (!line) return;
    line.classList.toggle('is-updating', busy);
    line.setAttribute('aria-busy', String(busy));
    line.querySelectorAll('button, input').forEach((control) => {
      control.disabled = busy;
    });
  }

  function setFormError(form, message) {
    if (!form) return;
    const error = form.querySelector('[data-form-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function change(payload, lineEl) {
    const sections = sectionParam();
    setLineBusy(lineEl, true);

    return BB.fetchJSON(ajaxUrl(routes.cartChange), {
      timeout: 10000,
      init: {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign(sections ? { sections } : {}, payload))
      }
    })
      .then((cart) => {
        renderCartSections(cart.sections);
        updateBadges(cart);
        document.dispatchEvent(new CustomEvent('bb:cart-updated', { detail: { cart } }));
        return cart;
      })
      .catch((err) => {
        setLineBusy(lineEl, false);
        BB.toast((err.body && (err.body.description || err.body.message)) || BB.t('cartUpdateError'));
      });
  }

  function add(form, button) {
    if (!button) return Promise.resolve();
    const data = new FormData(form);
    const sections = sectionParam();
    if (sections) data.append('sections', sections);

    setFormError(form, '');
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    return BB.fetchJSON(ajaxUrl(routes.cartAdd), {
      timeout: 10000,
      init: { method: 'POST', body: data, headers: { Accept: 'application/json' } }
    })
      .then((body) => {
        renderCartSections(body.sections);
        return BB.fetchJSON(ajaxUrl(routes.cart), { timeout: 10000 }).then((cart) => {
          updateBadges(cart);
        document.dispatchEvent(new CustomEvent('bb:cart-updated', { detail: { cart } }));
          BB.track('add_to_cart', {
            item_id: String(body.product_id),
            item_name: body.product_title,
            price: body.final_price / 100,
            quantity: body.quantity,
            currency: BB.config.currency
          });
          const drawer = document.getElementById('bb-cart-drawer');
          if (drawer) {
            BB.openDialog(drawer);
          } else {
            const link = document.createElement('a');
            link.href = routes.cart;
            link.textContent = BB.t('viewCart');
            const wrap = document.createElement('span');
            wrap.textContent = BB.t('added') + ' ';
            wrap.appendChild(link);
            BB.toast(wrap);
          }
        });
      })
      .catch((err) => {
        const message = (err.body && (err.body.description || err.body.message)) || err.message || BB.t('error');
        setFormError(form, message);
        BB.toast(message);
      })
      .finally(() => {
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-bb-cart-open]');
    if (open) {
      const dialog = document.getElementById('bb-cart-drawer');
      if (dialog) {
        e.preventDefault();
        BB.openDialog(dialog);
      }
      return;
    }

    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      const line = qtyBtn.closest('.bb-cart-line');
      if (!line || line.getAttribute('aria-busy') === 'true') return;
      const input = line.querySelector('[data-cart-qty-input]');
      const current = parseInt(input && input.value ? input.value : '0', 10);
      const delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10);
      const next = Math.max(0, (Number.isFinite(current) ? current : 0) + (Number.isFinite(delta) ? delta : 0));
      change({ id: line.getAttribute('data-key'), quantity: next }, line);
      return;
    }

    const remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      const line = remove.closest('.bb-cart-line');
      if (line && line.getAttribute('aria-busy') !== 'true') change({ id: line.getAttribute('data-key'), quantity: 0 }, line);
      return;
    }

    const checkout = e.target.closest('[data-bb-checkout]');
    if (checkout) BB.track('begin_checkout', { currency: BB.config.currency });
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-qty-input]');
    if (!input) return;
    const line = input.closest('.bb-cart-line');
    if (!line || line.getAttribute('aria-busy') === 'true') return;
    const value = parseInt(input.value || '0', 10);
    change({ id: line.getAttribute('data-key'), quantity: Math.max(0, Number.isFinite(value) ? value : 0) }, line);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-bb-product-form]');
    if (!form) return;
    e.preventDefault();
    add(form, form.querySelector('[type="submit"]'));
  });

  class BBCartDrawer extends HTMLElement {}
  if (!customElements.get('bb-cart-drawer')) customElements.define('bb-cart-drawer', BBCartDrawer);
})();
